import { getLevel } from '@infuse/iam/user/utils';
import { useI18n } from 'vue-i18n';

export const useAssetLevel = () => {
  const { t } = useI18n({ useScope: 'global' });

  // Using the navigation translation so customers UI can change this translation easily
  function getLevelTranslation(asset: { organisationId?: string; tenantId?: string }) {
    if (asset.organisationId) {
      return t('iam.organisations.nav.details');
    } else if (asset.tenantId) {
      return t('iam.tenants.nav.details');
    } else {
      return t('iam.domain.nav.details');
    }
  }

  return {
    getLevel,
    getLevelTranslation
  };
};
